import Shape from './Shape';

export default class Quad extends Shape {
  public type = 5
  constructor(item: any, index: number) {
    super(item, index)
  }
  get ctrlsData() {
    return this.coor;
  }
}
